import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { injectIntl } from 'react-intl'
// import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { Button } from 'components/misc'
import { Select, Input } from 'components/fields'
import { QuestionOptionCreator } from 'components/sections/profile-questions'
import { modal } from 'redux/modules/app'
import { form } from 'helpers/decorators'
import { validate } from 'models/profile-questions'
import Checkbox from '../../../../components/fields/Checkbox/Checkbox'
import { get } from 'lodash'

@injectIntl
@connect(null, { modal })
@form({
  form: 'form-add-new-question',
  validate,
  initialProps: 'data'
})
class QuestionForm extends Component {
  static propTypes = {
    data: PropTypes.object,
    intl: PropTypes.object,
    modal: PropTypes.func.isRequired,
    addNewQuestion: PropTypes.func.isRequired,
    requestClose: PropTypes.func.isRequired,
    editQuestion: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    questions: PropTypes.array.isRequired,
    valid: PropTypes.bool,
    values: PropTypes.object
  }

  static defaultProps = {
    values: {},
    isEditing: false
  }



  render() {
    const { values, handleSubmit, questions, valid, data, intl } = this.props

    let mustHaveOptions = false

    if (values.questionType === 'OPTIONS') {
      mustHaveOptions =
        !values.questionOptions ||
        (values.questionOptions && values.questionOptions.length === 0)
    }

    const isEditing = Boolean(data.id)

    const questionTypes = [
      {
        value: 'TEXT',
        label: intl.formatMessage({
          id: 'label.text',
          defaultMessage: 'Text'
        })
      },
      {
        value: 'OPTIONS',
        label: intl.formatMessage({
          id: 'label.options',
          defaultMessage: 'Options'
        })
      },
      {
        value: 'DATE',
        label: intl.formatMessage({
          id: 'label.date',
          defaultMessage: 'Date'
        })
      },
      {
        value: 'EMAIL',
        label: intl.formatMessage({
          id: 'label.email',
          defaultMessage: 'Email'
        })
      },
      {
        value: 'INTEGER',
        label: intl.formatMessage({
          id: 'label.integer',
          defaultMessage: 'Integer'
        })
      }
    ]

    return (
      <div>

        <Modal id="modal-add-new-question" customActions>
          <form
            onSubmit={handleSubmit(
              fields =>
                !isEditing
                  ? this.props.addNewQuestion(fields, questions)
                  : this.props.editQuestion(fields, questions)
            )}
          >
            <Select
              label="Question type"
              name="questionType"
              disabled={isEditing}
              options={questionTypes}
            />

            <div className="base-margin--bottom">
              <Input label="Question text" name="questionText" />

              {values.questionType === 'OPTIONS' && <QuestionOptionCreator />}
            </div>

            <Checkbox
                label="Answer is optional"
                intlKey="label.pq_is_optional"
                name="isOptional"
                justify
            />

            <Checkbox
                label="Questions/Answers not displayed on parental consent"
                intlKey="label.pq_parental_consent_hide"
                name="parentalConsentHide"
                justify
                disabled={get(values, 'parentalConsentOnly')}
            />

            <Checkbox
                label="Questions/Answers displayed only on parental consent"
                intlKey="label.pq_parental_consent_only"
                name="parentalConsentOnly"
                justify
                disabled={get(values, 'parentalConsentHide')}
            />

            <div className="row">
              <div className="col-xs-6">
                <Button
                  intlKey="button.close"
                  secondary
                  type="button"
                  onClick={this.props.requestClose}
                >
                  Close
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <Button
                  intlKey={isEditing ? 'button.save' : 'button.create'}
                  disabled={!values.questionType || !valid || mustHaveOptions}
                >
                  Create
                </Button>
              </div>
            </div>
          </form>
        </Modal>
      </div>
    )
  }
}

export default QuestionForm
